import React from "react";
import { useNavigate } from "react-router-dom";

const ThankYou = ({ next }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center my-12 gap-4">
      <p className="text-[20px] font-bold">
        Thank you for your interest in partnering with TrueKeepers.
      </p>
      <p className="text-[#7A7A7A]">
        We are constantly on the look out for credible NGO leaders who are
        implementing impactful projects across Nigeria that provide a better
        quality of life for the poor and vulnerable amongst us. If this sounds
        like you, then we would love to learn more about you and your
        organization. Please click on continue to fill the form and a member of
        our team will reach out soon.
      </p>
      <p className="text-[#7A7A7A]">
        If this sounds like you, then we would love to learn more about you and
        your organization.
      </p>
      <p className="text-[#7A7A7A]">
        Please click on continue to fill the form and a member of our team will
        reach out soon.
      </p>
      <button
        onClick={next}
        type="button"
        className="bg-[#213874] rounded-md text-white w-full p-2"
      >
        Continue
      </button>
      <button
        onClick={() => navigate(-1)}
        type="button"
        className="text-[#213874] rounded-md bg-white w-full p-2"
      >
        Back
      </button>
    </div>
  );
};

export default ThankYou;
